import React from "react";
import { SignOut } from "@phosphor-icons/react";
import { authLogout, UNAUTHORIZED_EVENT } from "@/lib/api";
import { useT } from "@/lib/i18n";

/** «Salir» siempre visible en la barra superior: cierra la sesión de este navegador y vuelve a la pantalla de acceso. */
export default function LogoutButton() {
    const t = useT();

    async function logout() {
        try {
            await authLogout();
        } finally {
            window.dispatchEvent(new Event(UNAUTHORIZED_EVENT)); // LoginGate muestra la pantalla de acceso
        }
    }

    return (
        <button
            data-testid="topbar-logout"
            onClick={logout}
            title={t("auth.logoutTitle")}
            aria-label={t("auth.logout")}
            className="px-2.5 py-1.5 text-xs bg-white border border-brand-300 text-brand-900 hover:bg-brand-100 font-medium flex items-center gap-1.5"
            translate="no"
        >
            <SignOut size={15} />
            <span className="hidden xl:inline">{t("auth.logout")}</span>
        </button>
    );
}
